import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import { doVxqlRequest } from './VxqlStore.js';
import { GetTopCams } from './TopCam.Queries.js';

function getKey(args) {
	return JSON.stringify(args);
}

const _topCamData = {};

const TopCamStore = assign({}, FluxEventEmitter.prototype, {
	getTopCamData(type, onlineOnly, callback) {
		const key = getKey(type + onlineOnly);
		if (_topCamData[key]) {
			callback(_topCamData[key]);
		} else {
			loadTopCamData({ type: type, online: onlineOnly }, (data) => {
				_topCamData[key] = data;
				callback(data);
			});
		}
	},
});

function loadTopCamData(args, callback) {
	doVxqlRequest(GetTopCams, args).then((result) => {
		const data = result.data.topCams;
		callback(data);
	});
}

export default TopCamStore;
